import { useState, useEffect, useCallback } from "react";
import TopNavBar from "./TopNavBar";
import { projectURL } from "./utils/mockdata";
import Modal from "./Modal"


const limit = 4; // Number of users per page

const formatDOB = (dob) => {
    if (!dob) return "N/A";
    const date = new Date(dob);
    const options = { day: "2-digit", month: "long", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
};

const FriendShimmer = () => (
    <>
        <div className="p-2">
            {[...Array(limit)].map((_, idx) => (
                <div className="flex items-center justify-between p-4 border-b animate-[wiggle_1s_ease-in-out_infinite]">
                    <div className="flex items-center space-x-4">
                        <div className="w-16 h-16 bg-gray-200 rounded-full"></div>
                        <div className="flex flex-col">
                            <div className="w-24 h-4 bg-gray-200 rounded"></div>
                        </div>
                    </div>
                    <div className="px-2 py-1 bg-blue-200 text-white rounded-lg hover:bg-blue-300 transition-all duration-600 text-md">Follow</div>
                </div>
            ))}
        </div>
        <div className="flex justify-between items-center p-4">
            <button type="button" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                <svg className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5H1m0 0l4-4m-4 4l4 4" />
                </svg>
            </button>
            <div className="text-gray-400 text-xl">
                ↺
            </div>
            <button type="button" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                <svg className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9" />
                </svg>
            </button>
        </div>
    </>

);


const FindFriend = () => {
    // State for storing users and pagination info
    const [users, setUsers] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);

    const [isModalOpen, setIsModalOpen] = useState(false)
    const [modalMessage, setModalMessage] = useState("")
    const [modalTitle, setModalTitle] = useState("")
    const [modalType, setModalType] = useState("info")

    const loggedUserId = sessionStorage.getItem("loggedUserId");

    const menus = [
        { label: "All", url: `${projectURL}profiles/userlist` },
        { label: "My Connections", url: `${projectURL}profiles/my-friends/` + loggedUserId },
        // { label: "Following", url: `${projectURL}profiles/userlist` },
        { label: "Friend Requests", url: `${projectURL}profiles/friend-requests/` + loggedUserId },
        { label: "Blocked", url: `${projectURL}profiles/my-blocks/` + loggedUserId }
    ];

    const [selectedMenu, setSelectedMenu] = useState(menus[0]); // default to "All"

    const [selectedUser, setSelectedUser] = useState(null);
    const [profileLoading, setProfileLoading] = useState(false);

    const fetchUserProfile = async (userId) => {
        setProfileLoading(true);
        try {
            const response = await fetch(`${projectURL}profiles/${userId}`);
            if (!response.ok) {
                throw new Error("Failed to fetch profile");
            }
            const data = await response.json();
            setSelectedUser(data); // store API response
        } catch (error) {
            console.error("Error fetching profile:", error);
            setSelectedUser({ error: "Could not load profile" });
        } finally {
            setProfileLoading(false);
        }
    };

    // Fetch users data based on current page
    const fetchUsers = useCallback(async () => {
        setLoading(true);
        try {

            const APIURL = `${selectedMenu.url}?page=${currentPage}&limit=${limit}&loggedUserId=${loggedUserId}`;

            const response = await fetch(APIURL);

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const data = await response.json();
            setUsers(data.users);
            setTotalPages(data.totalPages || 1);
        } catch (error) {
            console.error("Failed to fetch users:", error);
        } finally {
            setLoading(false);
        }
    }, [currentPage, selectedMenu, loggedUserId]);

    useEffect(() => {
        fetchUsers();
    }, [fetchUsers]);


    const handleFollow = async (receiverId) => {
        try {
            const senderId = loggedUserId; // from your session storage
            const response = await fetch(`${projectURL}profiles/send-friend-request`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    senderId,
                    receiverId
                })
            });

            const data = await response.json();

            if (response.ok) {
                setModalTitle("Success");
                setModalMessage("Friend request sent successfully!");
                setModalType("info");
                fetchUsers();
            } else {
                setModalTitle("Error");
                setModalMessage(data.message || "Failed to send friend request.");
                setModalType("error");
            }
        } catch (error) {
            console.error("Error sending friend request:", error);
            setModalTitle("Error");
            setModalMessage("Something went wrong.");
            setModalType("error");
        }

        setIsModalOpen(true);

        setTimeout(() => {
            setIsModalOpen(false);
        }, 1500);
    };


    const handleAccept = async (senderId) => {
        try {
            const receiverId = loggedUserId; // from your session storage
            const response = await fetch(`${projectURL}profiles/accept-friend-request`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    senderId,
                    receiverId,
                    "isAccepted": true,
                    "isBlocked": false
                })
            });
            const data = await response.json();
            if (response.ok) {
                setModalTitle("Success");
                setModalMessage("Friend request accepted successfully!");
                setModalType("info");
                fetchUsers();
            } else {
                setModalTitle("Error");
                setModalMessage(data.message || "Failed to accept friend request.");
                setModalType("error");
            }
        } catch (error) {
            console.error("Error accepting friend request:", error);
            setModalTitle("Error");
            setModalMessage("Something went wrong.");
            setModalType("error");
        }
        setIsModalOpen(true);
        setTimeout(() => {
            setIsModalOpen(false);
        }, 1500);
    };

    const handleReject = async (senderId) => {
        try {
            const receiverId = loggedUserId; // from your session storage
            const response = await fetch(`${projectURL}profiles/accept-friend-request`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    senderId,
                    receiverId,
                    "isAccepted": false,
                    "isBlocked": true
                })
            });
            const data = await response.json();
            if (response.ok) {
                setModalTitle("Success");
                setModalMessage("Friend request rejected successfully!");
                setModalType("info");
                fetchUsers();
            } else {
                setModalTitle("Error");
                setModalMessage(data.message || "Failed to reject friend request.");
                setModalType("error");
            }
        } catch (error) {
            console.error("Error rejecting friend request:", error);
            setModalTitle("Error");
            setModalMessage("Something went wrong.");
            setModalType("error");
        }
        setIsModalOpen(true);
        setTimeout(() => {
            setIsModalOpen(false);
        }, 1500);
    };


    // Placeholder for rendering user list

    const renderUsers = () => {
        return users.map(user => (
            <div key={user._id} className="flex items-center justify-between p-4 border-b">
                {/* Profile Info in a single line */}
                <div className="flex items-center space-x-4">
                    <img className="w-16 h-16 rounded-full" src={user.imagePath} alt={user.username} />
                    <div className="flex flex-col">
                        <h2 className="text-md font-bold text-black-500">{user.username}</h2>
                    </div>
                </div>

                {selectedMenu.label === "All" &&
                    (
                        <button
                            className="px-2 py-1 bg-blue-500 text-white rounded-lg hover:bg-violet-600 transition-all duration-600 text-md"
                            onClick={handleFollow.bind(null, user._id)}
                        >Follow</button>
                    )}

                {selectedMenu.label === "My Connections" &&
                    (
                        <div className="flex gap-2">
                            <button
                                className="px-2 py-1 bg-purple-500 text-white rounded-lg hover:bg-gray-600 transition-all duration-600 text-md"
                                onClick={() => {
                                    setSelectedUser(user);   // store clicked user
                                    setModalTitle("User Profile");
                                    setModalMessage("");     // clear generic message
                                    setModalType("info");
                                    setIsModalOpen(true);
                                    fetchUserProfile(user._id); // fetch detailed profile
                                }}
                            >
                                View Profile
                            </button>
                        </div>
                    )}

                {selectedMenu.label === "Friend Requests" &&
                    (
                        <div className="flex space-x-2">
                            <button
                                className="px-2 py-1 bg-blue-500 text-white rounded-lg hover:bg-gray-600 transition-all duration-600 text-md"
                                onClick={handleAccept.bind(null, user._id)}
                            >Accept</button>

                            <button
                                className="px-2 py-1 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-all duration-600 text-md"
                                onClick={handleReject.bind(null, user._id)}
                            >Reject</button>
                        </div>

                    )}

                {selectedMenu.label === "Blocked" &&
                    (
                        <button
                            className="px-2 py-1 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-all duration-600 text-md"
                            disabled
                        >Unblock</button>
                    )}
            </div>
        ));
    };

    // Handlers for pagination buttons
    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(prev => prev - 1);
        }
    };

    const goToNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(prev => prev + 1);
        }
    };

    return (
        <div className="min-h-full bg-gray-50">
            <TopNavBar />

            {/* Slidebar  Start*/}
            <div className="bg-white shadow-md sticky top-[60px]">
                <div className="overflow-x-auto">
                    <ul className="flex justify-center space-x-4 px-4 py-2 min-w-max">
                        {menus.map((menu) => (
                            <li
                                key={menu.label}
                                onClick={() => {
                                    setSelectedMenu(menu);
                                    setCurrentPage(1); // reset to page 1 when switching menu
                                }}
                                className={`cursor-pointer whitespace-nowrap px-4 py-2 rounded-full font-medium transition-colors ${selectedMenu.label === menu.label
                                    ? "bg-blue-500 text-white shadow-sm"
                                    : "bg-gray-100 text-gray-700 hover:bg-blue-100"
                                    }`}
                            >
                                {menu.label}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            {/* Slidebar  End*/}

            <div className="flex items-center justify-center p-6">
                <div className="mt-2 w-full max-w-4xl">
                    <div className="bg-white shadow-xl rounded-xl">
                        {loading ? (
                            <div className="text-center text-gray-500"><FriendShimmer /></div>
                        ) : users.length > 0 ? (
                            <>
                                <div className="divide-x divide-gray-200 overflow-y-auto max-h-112">
                                    {renderUsers()}
                                </div>

                                {/* Pagination Controls */}
                                <div className="flex justify-between items-center mt-4 p-4">
                                    {currentPage === 1 ? (
                                        <button onClick={goToPreviousPage} disabled type="button" className="text-white bg-gray-200 hover:bg-gray-400 focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center me-2">
                                            <svg className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5H1m0 0l4-4m-4 4l4 4" />
                                            </svg>
                                        </button>
                                    ) : (
                                        <button onClick={goToPreviousPage} type="button" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center me-2">
                                            <svg className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5H1m0 0l4-4m-4 4l4 4" />
                                            </svg>
                                        </button>
                                    )}

                                    <div className="text-gray-400 text-xs">
                                        {currentPage} of {totalPages}
                                    </div>

                                    {currentPage === totalPages ? (
                                        <button onClick={goToNextPage} disabled type="button" className="text-white bg-gray-200 hover:bg-gray-400 focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center me-2">
                                            <svg className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9" />
                                            </svg>
                                        </button>
                                    ) : (
                                        <button onClick={goToNextPage} type="button" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center me-2">
                                            <svg className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9" />
                                            </svg>
                                        </button>
                                    )}

                                </div>
                            </>
                        ) : (
                            <p className="text-gray-500 p-4">No users found.</p>
                        )}
                    </div>
                </div>
            </div>

            <Modal
                isOpen={isModalOpen}
                onClose={() => {
                    setIsModalOpen(false);
                    setSelectedUser(null);
                }}
                title={modalTitle}
                message={modalMessage}
                type={modalType}
            >
                {profileLoading && <p className="text-gray-500 text-center">Loading profile...</p>}

                {selectedUser && !profileLoading && !selectedUser.error && (
                    <div className="p-4 flex flex-col justify-between h-full min-h-[300px]">
                        <img
                            src={selectedUser.imagePath}
                            alt={selectedUser.username}
                            className="w-24 h-24 rounded-full border-blue-100 border-2 mb-4 mx-auto"
                        />
                        <h2 className="text-lg font-bold text-center">{selectedUser.username}</h2>
                        <p className="text-sm text-gray-600"><b>Email: </b>{selectedUser.email}</p>
                        <p className="text-sm text-gray-600"><b>Mobile: </b>{selectedUser.mobile || "N/A"}</p>
                        <p className="text-sm text-gray-600"><b>DOB: </b>{formatDOB(selectedUser.DOB) || "N/A"}</p>
                        <p className="text-sm text-gray-600"><b>Hobbies: </b>{selectedUser.Hobbies.join(", ") || "None"}</p>
                    </div>
                )}

                {selectedUser?.error && (
                    <p className="text-red-500 text-center">{selectedUser.error}</p>
                )}
            </Modal>
        </div>
    );
};

export default FindFriend;